const numeroOuNulo = (valor) =>
  valor === null || valor === undefined ? null : Number(valor);

export const variacaoPercentual = (atual, anterior) => {
  if (atual === null || !anterior) return null;
  return Math.round((atual / anterior - 1) * 10000) / 100;
};

export const variacaoEmPontos = (atual, anterior) => {
  if (atual === null || anterior === null) return null;
  return Math.round((atual - anterior) * 100) / 100;
};

const metricasDoPeriodo = ({ revenue, conversion, derived }) => {
  const conversao = conversion?.branches?.[0];
  const derivadas = derived?.branches?.[0];
  return {
    faturamento: numeroOuNulo(revenue?.totals?.bruto_vendas),
    faturamentoPorAtencao: numeroOuNulo(
      derivadas?.faturamento_por_pessoa_minuto
    ),
    oportunidades: numeroOuNulo(conversao?.oportunidades),
    conversao: numeroOuNulo(conversao?.conversao_pct),
  };
};

export const cartoesDaEmAlta = ({ atual, anterior }) => {
  if (!atual?.revenue || !atual?.conversion || !atual?.derived) return null;
  const agora = metricasDoPeriodo(atual);
  const antes = metricasDoPeriodo(anterior || {});
  return {
    faturamento_total: agora.faturamento,
    variacao_faturamento_total: variacaoPercentual(
      agora.faturamento,
      antes.faturamento
    ),
    faturamento_por_tempo_permanencia: agora.faturamentoPorAtencao,
    variacao_faturamento_por_tempo_permanencia: variacaoPercentual(
      agora.faturamentoPorAtencao,
      antes.faturamentoPorAtencao
    ),
    oportunidades: agora.oportunidades,
    variacao_oportunidades: variacaoPercentual(
      agora.oportunidades,
      antes.oportunidades
    ),
    conversao: agora.conversao,
    variacao_conversao: variacaoEmPontos(agora.conversao, antes.conversao),
  };
};

const compararNomes = (a, b) =>
  a.description.localeCompare(b.description, "pt-BR");

export const rankingDaEmAlta = (itens, nome, valor) => {
  const ordenados = (itens || [])
    .map((item) => ({
      description: nome(item),
      value: Number(valor(item) || 0),
    }))
    .filter((item) => item.value > 0)
    .sort((a, b) => b.value - a.value || compararNomes(a, b));
  return {
    primeiras: ordenados.slice(0, 3),
    ultimas: ordenados.slice(3).slice(-3),
  };
};

const rankingsPorGrupo = (itens, nome, valores, sufixo) =>
  Object.fromEntries(
    Object.entries(valores).map(([grupo, valor]) => {
      const { primeiras, ultimas } = rankingDaEmAlta(itens, nome, valor);
      return [
        grupo,
        { [`first_${sufixo}`]: primeiras, [`last_${sufixo}`]: ultimas },
      ];
    })
  );

export const rankingsDeZonas = (derived) => {
  const zonas = derived?.branches?.[0]?.zones;
  if (!zonas) return null;
  return rankingsPorGrupo(
    zonas.filter((zona) => !zona.is_staff_zone),
    (zona) => zona.zone_name,
    {
      revenue: (zona) => zona.faturamento_presencial,
      occupation: (zona) => zona.pessoa_minuto,
      revenue_per_minute: (zona) => zona.faturamento_por_pessoa_minuto,
    },
    "zones"
  );
};

export const rankingsDeCategorias = (eficiencia) => {
  const colecoes = eficiencia?.branches?.[0]?.colecoes;
  if (!colecoes) return null;
  return rankingsPorGrupo(
    colecoes,
    (colecao) => colecao.colecao,
    {
      revenue: (colecao) => colecao.faturamento,
      occupation: (colecao) => colecao.minutos,
      revenue_per_minute: (colecao) => colecao.r_por_min,
    },
    "collections"
  );
};
